import { MANIFESTO_CHAPTERS } from "@/data";
import { Reveal, MaskLine } from "@/components/Reveal";

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="mb-20 lg:mb-28 max-w-3xl">
        <Reveal>
          <p className="eyebrow mb-5">Our Manifesto</p>
        </Reveal>
        <h2 className="font-display font-medium leading-[1.02] tracking-tight text-4xl sm:text-5xl lg:text-6xl">
          <MaskLine>Three things we</MaskLine>
          <MaskLine delay={0.12}>
            never <span className="italic text-[#C85A32]">rush.</span>
          </MaskLine>
        </h2>
      </div>
      <div className="space-y-24 lg:space-y-36">
        {MANIFESTO_CHAPTERS.map((c) => (
          <Reveal key={c.num}>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
              <div className="lg:col-span-4 lg:sticky lg:top-32">
                <span
                  data-testid={`manifesto-chapter-${c.num}`}
                  className="font-display italic text-[6rem] sm:text-[8rem] leading-none text-[#C85A32]/25 select-none block"
                >
                  {c.num}
                </span>
                <p className="font-mono-accent text-xs tracking-[0.25em] uppercase text-[#1C130E]/50 mt-2">{c.label}</p>
              </div>
              <div className="lg:col-span-4">
                <h3 className="font-display font-medium text-3xl sm:text-4xl leading-tight tracking-tight">{c.title}</h3>
                <p className="mt-5 text-base leading-relaxed text-[#1C130E]/75 max-w-md">{c.body}</p>
              </div>
              <div className={`lg:col-span-4 ${c.offset}`}>
                <div className="overflow-hidden rounded-[1.5rem] rounded-tl-[999px] shadow-[0_30px_60px_-25px_rgba(28,19,14,0.35)]">
                  <img
                    alt={c.alt}
                    loading="lazy"
                    className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-[1.2s] ease-out"
                    src={c.img}
                  />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
